import { useEffect, useState } from 'react';
import api from '../../../lib/api';

export const AuthImage = ({ src, alt, className }) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let objectUrl;
    api.get(src, { responseType: 'blob' }).then((r) => { objectUrl = URL.createObjectURL(r.data); setUrl(objectUrl); }).catch(() => setUrl(null));
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [src]);
  if (!url) return <div className={`${className} bg-muted animate-pulse w-28`} />;
  return <a href={url} target="_blank" rel="noreferrer"><img src={url} alt={alt} className={`${className} object-contain bg-white`} /></a>;
};
